import React, { memo, useRef, useEffect, useState } from 'react';

import { connect } from 'react-redux';
import action from '@flux/action';
import { Col, Row } from 'antd';
import { Button as SubmitButton } from 'appkit-react';
import { useHistory } from 'react-router-dom';
import { deepCopy } from '@utils/common';
import TeamForm from './teamForm';
import CanNotFindMemberHint from '../cannotFindMemberHint';
import { PWC_TEAM_BULK_ADD_HELPER } from '../projectSetting/utils/bulkAddUsers.ui';
import { projectRole, oldProjectRoleNames } from '@model';

const TeamDetailFrom = (props) => {
  const history = useHistory();
  const {
    steps,
    tranStep,
    changeTeamsDetail,
    memberData,
    operatorName,
    saveNamesResult,
    saveData,
    saveCreateProjectData,
    getTeamsDefaultMembers,
    getTeamsSetting,
    saveTeamsNames,
    userInfo,
  } = props;
  const teamFormRef = useRef();
  const [initialized, setInitialized] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const hasFilled = (_form) => {
    const fieldsValue = _form.getFieldsValue();
    const isValid = (e) => typeof e !== 'undefined' && e !== '' && e?.email;
    const hasValidMember = (members) => members?.some(isValid);
    return (
      // isValid(fieldsValue.engagementLead) ||
      // isValid(fieldsValue.engagementManager) ||
      hasValidMember(fieldsValue.teamMember)
    );
  };

  useEffect(() => {
    const form = teamFormRef.current.getForm();
    if (hasFilled(form)) {
      return;
    }
    if (memberData.length === 0) {
      getTeamsDefaultMembers(userInfo);
    } else {
      const memberRefract = { lead: {}, manager: {}, members: [] };
      for (const i in memberData) {
        memberRefract.members.push(memberData[i]);
      }
      getTeamsSetting(memberRefract);
    }
  }, [userInfo, getTeamsDefaultMembers]);

  useEffect(() => {
    const operatorInfo = deepCopy(memberData)
      // .map((item) => item.fullName)
      .pop();
    const members = [...new Set(memberData)].filter((member) => member?.email);
    if (members.length === 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
    const form = teamFormRef.current.getForm();
    if (
      !operatorInfo ||
      initialized ||
      hasFilled(form)
      // operatorInfo.guid !== userInfo.uid
    ) {
      return;
    }
    memberData && form.setFieldsValue({ teamMember: [...memberData] });
    setInitialized(true);
  }, [memberData]);

  const handlePrevious = async () => {
    const value = teamFormRef.current.getForm().getFieldValue();
    await teamFormRef.current.validateForm(value.teamMember);
    saveCreateProjectData({
      ...saveData,
      currentStep: tranStep(steps[0]),
    });

    changeTeamsDetail(value);
    history.push(`/projects/create/${steps[0]}`);
  };

  const handleSubmit = async (data) => {
    const value = [...new Set(memberData)].filter((member) => member?.guid);
    await teamFormRef.current.validateForm(value);
    if (value.length === 0) {
      return;
    }
    for (const i in value) {
      if (value[i]?.email) {
        switch (value[i].role_name) {
          case oldProjectRoleNames[0]:
            value[i].isManager = false;
            value[i].isLead = true;
            break;
          case oldProjectRoleNames[1]:
            value[i].isManager = true;
            value[i].isLead = false;
            break;
          default:
            value[i].isManager = false;
            value[i].isLead = false;
        }
      }
    }

    changeTeamsDetail(value);
    saveTeamsNames({ saveNamesResult, memberData: value });
    saveCreateProjectData({
      currentStep: tranStep(steps[1]),
      isEditing: false,
      // companyData,
    });
    history.push(`/projects/create/${steps[1]}`);
    // }
  };

  const renderAction = () => (
    <Row justify="space-between">
      <Col>
        <SubmitButton
          kind="secondary"
          onMouseDown={handlePrevious}
          className="previous-btn"
          size="lg"
        >
          previous
        </SubmitButton>
      </Col>
      <Col>
        <SubmitButton
          kind="primary"
          size="lg"
          style={{ width: 150 }}
          onClick={handleSubmit}
          className="create-btn"
          disabled={disabled}
        >
          next
        </SubmitButton>
      </Col>
    </Row>
  );

  return (
    <div className="pwc-team-member pwcTeamDetails">
      <div className="createPrompt">{PWC_TEAM_BULK_ADD_HELPER}</div>
      <CanNotFindMemberHint />
      <TeamForm cref={teamFormRef} renderAction={renderAction} createStep />
    </div>
  );
};

const mapStateToProps = ({ projects, login }) => ({
  teamsData: projects.teamsData || {},
  queryNamesResult: projects.queryNamesResult || [],
  saveNamesResult: projects.saveNamesResult || [],
  fetching: projects.changeQueryNamesLoading,
  memberData: projects.memberData,
  operatorName: `${login.userInfo.given_name} ${login.userInfo.family_name}`,
  saveData: projects.saveData,
  userInfo: login.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
  changeTeamsDetail(data) {
    dispatch(action.changeTeamsDetail(data));
  },
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
  saveTeamsNames(data) {
    dispatch(action.saveTeamsNames(data));
  },
  getTeamsDefaultMembers(userInfo) {
    dispatch(action.getTeamsDefaultMembers(userInfo));
  },
  getTeamsSetting(data) {
    dispatch(action.getTeamsSetting(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(TeamDetailFrom));
